/* Carousel container */
.container {
  padding-left: var(--spaces-48);
  padding-right: var(--spaces-48);
  position: relative;
  width: 100%;
}

.mask {
  mask-image: linear-gradient(
    to right,
    transparent 0px,
    black var(--spaces-12),
    black calc(100% - var(--spaces-12)),
    transparent 100%
  );
  overflow: hidden;
  position: relative;
  width: 100%;
}

.scrollContainer {
  height: calc(var(--item-height) + var(--padding-top) + var(--padding-bottom));
  position: relative;
}

/* Arrow placement */
.arrowPlacement {
  position: absolute;
  z-index: var(--z-indices-popover);
}

.arrowPlacement[data-orientation='horizontal'] {
  top: calc(var(--padding-top) + var(--item-height) / 2);
  transform: translateY(-50%);
}

.arrowPlacement[data-orientation='horizontal'][data-position='start'] {
  left: 0;
}

.arrowPlacement[data-orientation='horizontal'][data-position='end'] {
  right: 0;
}

.arrowPlacement[data-orientation='vertical'] {
  left: calc(var(--padding-left) + var(--item-width) / 2);
  transform: translateX(-50%);
}

.arrowPlacement[data-orientation='vertical'][data-position='start'] {
  top: 0;
}

.arrowPlacement[data-orientation='vertical'][data-position='end'] {
  bottom: 0;
}

/* Checkbox position */
.checkboxPosition {
  isolation: isolate;
  left: var(--spaces-8);
  outline: none;
  position: absolute;
  top: var(--spaces-8);
  transition: opacity 0.2s ease;
}

.checkboxPosition::before {
  border-top-left-radius: var(--radii-8);
  content: '';
  cursor: pointer;
  height: var(--spaces-32);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--spaces-32);
}

/* Carousel list item styles */
.animationContainer {
  position: absolute;
}

.textContainer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  left: 0;
  opacity: 0;
  padding-top: 15px;
  position: absolute;
  top: var(--item-height);
  transform: translateY(-5px);
  transition: all 0.2s ease;
  width: var(--item-width);
}

.textContainer[data-hovered] {
  opacity: 1;
  transform: translateY(0);
}

.countBadge {
  background-color: var(--colors-background-secondary);
  border-radius: 15px;
  bottom: 4px;
  color: var(--colors-text-body);
  font-weight: var(--font-weights-medium);
  font-size: var(--font-sizes-50);
  line-height: var(--line-heights-50);
  left: 50%;
  opacity: 0;
  padding: var(--spaces-2) var(--spaces-8);
  position: absolute;
  transform: translateY(5px) translateX(-50%);
  transition: all 0.2s ease;
  white-space: nowrap;
}

.countBadge[data-hovered] {
  opacity: 1;
  transform: translateY(0) translateX(-50%);
}

.carouselItem {
  height: var(--item-height);
  outline: none;
  position: relative;
  transform: scale(1);
  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  width: var(--item-width);
}

.carouselItem[data-has-action] {
  cursor: pointer;
}

/* unstyled variant - no additional styles */
.carouselItem[data-variant='unstyled'] {
  /* empty */
}

/* small variant */
.carouselItem[data-variant='small'] {
  --radius: var(--spaces-6);
  background-color: var(--colors-background-secondary);
  border-radius: var(--radius);
  filter: drop-shadow(0px 16px 10px rgba(0, 0, 0, 0.2));
}

.carouselItem[data-variant='small'][data-focused] {
  outline: 2px solid var(--colors-border-interactive-focused);
  outline-offset: 2px;
}

.carouselItem[data-variant='small'][data-activated] {
  box-shadow: 0 0 0 1.25px var(--colors-brand-primary);
  transform: scale(1.2);
}

.carouselItem[data-variant='small'][data-hovered][data-has-action]:not([data-activated]) {
  box-shadow: 0 0 0 1.36px var(--colors-brand-light);
  transform: scale(1.1);
}

.carouselItem[data-variant='small'][data-dragging] {
  opacity: 0.5;
  transform: scale(1);
}

.carouselItem[data-variant='small'][data-drop-target] {
  outline: 2px solid var(--colors-brand-primary);
  outline-offset: 2px;
  transform: scale(1);
}

.backgroundLink {
  inset: 0;
  position: absolute;
}
